/* Shipping protection opt-in (Legal pattern (a), 2026-10-07).
   Unchecked by default. Adds SP only when the shopper ticks the box. Never auto-adds. */
(() => {
  if (window.__spOptinLoaded) return;
  window.__spOptinLoaded = true;

  const SEL = '[data-sp-optin]';
  let pending = null;   // promise while a cart change and re-render is in flight
  let reconciling = false;

  const cfg = () => {
    const el = document.querySelector(SEL);
    if (!el) return null;
    const plans = (el.dataset.spPlans || '')
      .split(',').filter(Boolean)
      .map((p) => p.split(':').map(Number));
    return { productId: Number(el.dataset.spProductId), pct: Number(el.dataset.spPct || 5), plans };
  };

  const tier = (c, basisCents) => {
    const target = (basisCents * c.pct) / 100;
    let best = null, bestDiff = Infinity;
    for (const [id, cents] of c.plans) {
      const d = Math.abs(cents - target);
      if (d < bestDiff) { best = id; bestDiff = d; }
    }
    return best;
  };

  const getCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((r) => r.json());
  const update = (updates) =>
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates }),
    }).then((r) => { if (!r.ok) throw new Error('cart update ' + r.status); return r.json(); });

  // Ask the theme to re-render cart sections. Resolve when it signals unlock (or after a timeout).
  const refresh = () => new Promise((resolve) => {
    let done = false;
    const finish = () => { if (!done) { done = true; document.removeEventListener('shapes:cart:unlock', finish); setTimeout(resolve, 50); } };
    document.addEventListener('shapes:cart:unlock', finish);
    setTimeout(finish, 5000);
    document.dispatchEvent(new CustomEvent('theme:update:cart'));
  });

  const setBoxes = (checked, disabled) => {
    document.querySelectorAll(SEL + ' .sp-optin__input').forEach((i) => {
      if (checked !== undefined) i.checked = checked;
      if (disabled !== undefined) i.disabled = disabled;
    });
    document.documentElement.classList.toggle('sp-optin-busy', !!disabled);
  };

  const split = (cart, c) => {
    const sp = cart.items.filter((i) => i.product_id === c.productId);
    const basis = cart.items.filter((i) => i.product_id !== c.productId).reduce((s, i) => s + i.final_line_price, 0);
    return { sp, basis };
  };

  const run = (fn) => {
    const p = (async () => { try { await fn(); } catch (e) { console.error('[sp-optin]', e); } finally { if (pending === p) pending = null; } })();
    pending = p;
    return p;
  };

  async function setProtection(on) {
    const c = cfg(); if (!c) return;
    setBoxes(on, true);
    try {
      const cart = await getCart();
      const { sp, basis } = split(cart, c);
      const updates = {};
      sp.forEach((i) => { updates[i.variant_id] = 0; });
      if (on && basis > 0) updates[tier(c, basis)] = 1;
      if (Object.keys(updates).length) await update(updates);
      await refresh();
      const after = split(await getCart(), c);
      setBoxes(after.sp.length > 0, false);
    } catch (e) {
      console.error('[sp-optin]', e);
      const err = document.getElementById('cart-errors');
      if (err) err.textContent = 'Sorry, we could not update shipping protection. Please try again.';
      setBoxes(!on, false);
    }
  }

  // Keep the SP line consistent with the cart (right tier, quantity 1, removed if it is the only item).
  // Never adds protection that isn't already in the cart.
  async function reconcile() {
    const c = cfg(); if (!c || !c.plans.length || reconciling || pending) return;
    reconciling = true;
    try {
      const cart = await getCart();
      const { sp, basis } = split(cart, c);
      if (sp.length === 0) { setBoxes(false); return; }
      const target = basis > 0 ? tier(c, basis) : null;
      const ok = target && sp.length === 1 && sp[0].variant_id === target && sp[0].quantity === 1;
      if (!ok) {
        await run(async () => {
          const updates = {};
          sp.forEach((i) => { updates[i.variant_id] = 0; });
          if (target) updates[target] = 1;
          await update(updates);
          await refresh();
        });
      }
      setBoxes(!!target);
    } catch (e) {
      console.error('[sp-optin]', e);
    } finally {
      reconciling = false;
    }
  }

  document.addEventListener('change', (e) => {
    const box = e.target.closest && e.target.closest(SEL + ' .sp-optin__input');
    if (!box) return;
    run(() => setProtection(box.checked));
  });

  // Hold any checkout click until a protection change and re-render have finished.
  const holdCheckout = (e) => {
    const btn = e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"]');
    if (!btn || !pending) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pending.then(() => setTimeout(() => btn.click(), 0));
  };
  document.addEventListener('click', holdCheckout, true);
  document.addEventListener('submit', (e) => {
    if (!pending) return;
    const submitter = e.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pending.then(() => setTimeout(() => submitter.click(), 0));
  }, true);

  let t;
  const later = () => { clearTimeout(t); t = setTimeout(reconcile, 400); };
  ['shapes:cart:update', 'shapes:cart:afteradditem', 'shapes:cart:cartqtychange'].forEach((n) => window.addEventListener(n, later));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', later); else later();
})();
